import React from 'react';
import './MobileFooter.css';

function MobileFooter({
  showInformation,
  toggleBackgroundColor,
  setShowDetails,
  showDetails,
  setShowAbout,
  showAbout,
  setShowContactInformation,
  showContactInformation
}) {
  const handleDetailsClick = () => {
    setShowDetails(!showDetails);
    setShowAbout(false);
    setShowContactInformation(false);
  };

  const handleContactClick = () => {
    setShowContactInformation(!showContactInformation);
    setShowDetails(false);
    setShowAbout(false);
  };

  return (
    <div className="mobile-footer p-4">
      {!showInformation && !showContactInformation && (
        <React.Fragment>
          <button
            className={`mobile-footer-button ${showDetails ? 'selected' : ''}`} style={{ position: 'relative', zIndex: !showAbout ? 3 : '' }}
            onClick={handleDetailsClick}
          >
            {showDetails ? 'CLOSE' : 'DETAILS'}
          </button>
        </React.Fragment>
      )}
      {!showContactInformation && !showInformation && (
        <label className="switch" style={{ opacity: showDetails ? 0 : 1 }}>
          <input
            type="checkbox"
            onChange={toggleBackgroundColor}
          />
          <span className="slider round"></span>
        </label>
      )}
      {!showInformation && (
        <div className="contact-container" style={{ opacity: showDetails ? 0 : 1 }}>
          {showContactInformation ? (
            <div className="contact-info">
              <a href="mailto:info@christian-horrer.com">INFO@CHRISTIAN-HORRER.COM</a>
              <span>LINKEDIN</span>
              <a href='https://www.instagram.com/christianhorrer/' target='_blank' rel="noreferrer">INSTAGRAM</a>
              <button
                className="mobile-footer-button selected ml-3" style={{ position: 'relative', zIndex: !showAbout ? 3 : '' }}
                onClick={handleContactClick}
              >
                CLOSE
              </button>
            </div>
          ) : (
            <button
              className="mobile-footer-button"
              onClick={handleContactClick}
            >
              CONTACT
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default MobileFooter;
